module.exports = __webpack_public_path__ + "img/app-store-badge.77ca8b6d.png";